/**
 * 轮播剧集清单（纯数据，唯一来源）。
 *
 * 名称与一句话简介取自 assets/images/carousel 各张海报的角标区。抄进代码是因为
 * 海报里的字是像素，搜索引擎读不到：
 *   - 运行时：carouselItems.js 据此给轮播每张图补 alt；
 *   - 构建期：vue.config.js 把这份清单喂给 html-webpack-plugin，
 *     public/index.html 用它渲染首屏静态文案和 ItemList 结构化数据。
 * 所以改剧集只改这里，三处输出都会跟着变。
 *
 * 用 CommonJS 是因为 vue.config.js 要在 Node 里直接 require 它（不能带图片 require）。
 *
 * 注：6.webp 的角标误印成「小少妇」（与 1.webp 重名），这里按海报主标题取《偷窥游戏》。
 */
module.exports = [
  { file: 1, name: "小少妇", desc: "年轻少妇的禁忌日常" },
  { file: 2, name: "母女同侍", desc: "一个秘密，改变三个人的人生" },
  { file: 3, name: "熟女也疯狂", desc: "谁说熟女不疯狂？她的精彩才刚开始" },
  { file: 4, name: "浪荡骚逼", desc: "浪荡姐姐专操纯情少男" },
  { file: 5, name: "黑暗圣经", desc: "信仰的禁地 · 欲望的圣坛" },
  { file: 6, name: "偷窥游戏", desc: "偷窥别人的生活，才是最刺激的自由" },
  { file: 7, name: "长途列车", desc: "朱颜血系列 · 午夜车厢的疯狂" }
];
